import FormInput from "components/ui/formComponents/FormInput";
import FormModal from "components/ui/formComponents/FormModel";
import FormTextArea from "components/ui/formComponents/FormTextArea";
import React, { useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const SalesForm = ({ isOpen, onClose, onSubmit, editingSales, initialData, onFormChange }) => {
    // Auto-calculate totalAmount and update the parent's state via onFormChange
    useEffect(() => {
        const qty = parseFloat(initialData.qty) || 0;
        const price = parseFloat(initialData.unitPrice) || 0;
        onFormChange({
            target: {
                name: "totalAmount",
                value: (qty * price).toFixed(2)
            }
        });
    }, [initialData.qty, initialData.unitPrice, onFormChange]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        isOpen && (
            <FormModal
                title={editingSales ? "Edit Sales" : "Add Manual Sale"}
                onClose={onClose}
                onSubmit={handleSubmit}
                disabled={
                    !initialData.productName ||
                    !initialData.saleDate ||
                    !initialData.qty ||
                    parseFloat(initialData.qty) <= 0 ||
                    initialData.unitPrice === "" ||
                    !/^-?\d*\.?\d{0,2}$/.test(initialData.unitPrice) ||
                    parseFloat(initialData.unitPrice) < 0 ||
                    parseFloat(initialData.totalAmount) <= 0
                }
                submitText={editingSales ? "Update" : "Create"}
            >
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
                    <div className="mb-4">
                        <label htmlFor="saleDate" className="text-sm font-medium">
                            Sale Date <span className="text-red-500">*</span>
                        </label>
                        <DatePicker
                            id="saleDate"
                            placeholder="Select date"
                            format="YYYY-MM-DD"
                            className={`
      block w-full rounded-md shadow-sm
      focus:ring-[#4096ff] focus:ring-0 focus:outline-none
      hover:border-[#4096ff]
      border-gray-300 focus:border-[#1677ff]
      focus:shadow-[0_0_0_2px_rgba(64,150,255,0.1)]
    `}
                            style={{
                                width: "100%",
                                borderRadius: "0.375rem",
                                height: "40px",
                                lineHeight: "38px",      // makes text vertically center
                                display: "flex",
                                alignItems: "center",    // centers placeholder/content
                            }}
                            value={initialData.saleDate ? dayjs(initialData.saleDate) : null}
                            onChange={(date, dateString) =>
                                onFormChange({
                                    target: {
                                        name: "saleDate",
                                        value: dateString,
                                    },
                                })
                            }
                        />
                    </div>

                    <FormInput
                        label="Product Name"
                        name="productName"
                        value={initialData.productName}
                        onChange={onFormChange}
                        placeholder="Enter product name"
                    />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px' }}>
                    <FormInput
                        label="Unit Price"
                        name="unitPrice"
                        type="text"
                        value={initialData.unitPrice}
                        onChange={(e) => {
                            const value = e.target.value;
                            if ((/^-?\d*\.?\d{0,2}$/.test(value) || value === "")) {
                                if (value !== "0" && value !== "0.0" && value !== "0.00") {
                                    onFormChange(e);
                                }
                            }
                        }}
                        placeholder="Enter unit price"
                        min={0}
                    />
                    <FormInput
                        label="Qty"
                        name="qty"
                        type="text"
                        value={initialData.qty}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
                                onFormChange(e);
                            }
                        }}
                        placeholder="Enter quantity"
                    />
                    <FormInput
                        label="Total Amount"
                        name="totalAmount"
                        type="number"
                        value={initialData.totalAmount}
                        readOnly
                    />
                </div>

                <FormTextArea
                    label="Notes (optional)"
                    name="notes"
                    value={initialData.notes}
                    onChange={onFormChange}
                    placeholder="Additional notes"
                />
            </FormModal>
        )
    );
};

export default SalesForm;